import { featureFlagsApiRef, useApi } from '@backstage/core-plugin-api';
import { DATA_GOVERNANCE_TAGS_FLAG } from '@internal/yardstick-react';

/**
 * Whether the `pfg-data-asset-owner` tag should be shown and written.
 *
 * The flag is registered by the yardstick-react plugin from its gated
 * measurements map, so the same toggle also hides the Data Asset Owner
 * Compliance findings. It is off by default, which keeps the tags hidden until
 * the feature is ready.
 */
export const useDataGovernanceTagsEnabled = (): boolean => {
  const featureFlagsApi = useApi(featureFlagsApiRef);
  return featureFlagsApi.isActive(DATA_GOVERNANCE_TAGS_FLAG);
};
